import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import * as styles from './MetaHelpFooter.css';

function MetaHelpFooter(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Flex align={'center'} gap={theme.spacing['1']} justify={'center'}>
      <Text.DefaultRegular>{t('Need help setting up? ')}</Text.DefaultRegular>
      <Text.DefaultRegular className={styles.helpLink} href={'#'} inline={true} target={'_blank'}>
        {t('View setup guide')}
      </Text.DefaultRegular>
      <Text.DefaultRegular>{t(' or ')}</Text.DefaultRegular>
      <Text.DefaultRegular className={styles.helpLink} href={'#'} inline={true} target={'_blank'}>
        {t('contact support')}
      </Text.DefaultRegular>
    </Flex>
  );
}

export default MetaHelpFooter;
